import React, { FC } from 'react'
import { Images } from '@nsw-paginas-deslogadas/assets'
import * as S from './styles'

export type TopicItemProps = {
    icon: keyof typeof Images
    title: string
    text: string
}

const Item: FC<TopicItemProps> = ({ icon, title, text }) => {
    return (
        <S.Topic style={{ display: 'flex' }}>
            <S.ImgCircle>
                <S.Img alt={Images[icon].alt} src={Images[icon].src} />
            </S.ImgCircle>
            <div>
                <S.Title>{title}</S.Title>
                <S.Text>{text}</S.Text>
            </div>
        </S.Topic>
    )
}

export type TopicGroupProps = {
    items: TopicItemProps[]
}

const Group: FC<TopicGroupProps> = ({ items }) => {
    return (
        <S.Container>
            <S.Group>
                {items.map((item, index) => {
                    return <Item {...item} key={index} />
                })}
            </S.Group>
        </S.Container>
    )
}

const TopicV2 = { Group, Item }
export default TopicV2
